import { PayloadAction } from '@reduxjs/toolkit';
import { Shape } from '../../shapeValidation/slice/types';

export const reducers = {
  setShape(state, action: PayloadAction<Shape>) {
    state.shape = action.payload;
    state.fieldFocused = {
      ring: 'outerDiameter',
      disc: 'outerDiameter',
      strip: 'length',
      frame: 'outsideLength',
    }[action.payload];
    const valuesInStore = JSON.parse(
      localStorage.getItem('formInitialValues') || '{}',
    );
    localStorage.setItem(
      'formInitialValues',
      JSON.stringify({
        erpPartNumber: valuesInStore.erpPartNumber,
        shapeUsed: action.payload,
      }),
    );
  },
  setFocusedField(state, action: PayloadAction<string>) {
    state.fieldFocused = action.payload;
  },
};
